module.exports = __webpack_public_path__ + "static/scenario-activity-dashboard-b3d52829d200140e9feff28a1b015ce0.png";